import React from 'react';

const NumerisationModal = ({
  show, onClose,
  numSubmitted, setNumSubmitted,
  numForm, setNumForm,
  onSubmit,
  inputStyle, t,
}) => {
  if (!show) return null;
  return (
    <div data-testid="numerisation-modal-overlay" onClick={onClose} style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
    }}>
      <div onClick={e => e.stopPropagation()} data-testid="numerisation-modal" style={{
        position: 'relative', backgroundColor: '#0a0a0a',
        border: '1px solid rgba(212,175,55,0.3)',
        borderRadius: 16, padding: '36px 32px', maxWidth: 480, width: '90%',
      }}>
        <button onClick={onClose} style={{
          position: 'absolute', top: 14, right: 18,
          background: 'none', border: 'none',
          color: '#D4AF37', fontSize: 24, cursor: 'pointer',
        }}>&times;</button>
        {numSubmitted ? (
          <div className="text-center" style={{ padding: '24px 0' }}>
            <div style={{
              width: 48, height: 48, borderRadius: '50%', margin: '0 auto 16px',
              backgroundColor: 'rgba(212,175,55,0.1)', border: '2px solid #D4AF37',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <p data-testid="numerisation-success" style={{ fontFamily: "'Georgia', serif", fontSize: 18, color: '#D4AF37', marginBottom: 10 }}>{t('svc_request_sent')}</p>
            <p style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#FAF3E0', lineHeight: 1.6 }}>{t('svc_request_sent_desc')}</p>
            <button onClick={() => { onClose(); setNumSubmitted(false); }} data-testid="numerisation-close-btn" style={{ background: 'none', border: 'none', cursor: 'pointer', marginTop: 20, padding: 8 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        ) : (
          <>
            <h3 style={{ fontFamily: "'Georgia', serif", fontSize: 22, color: '#D4AF37', textAlign: 'center', marginBottom: 24 }}>{t('svc_digitize_title')}</h3>
            <form onSubmit={onSubmit}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <input type="text" placeholder="Votre nom" required value={numForm.name} onChange={e => setNumForm(f => ({ ...f, name: e.target.value }))} data-testid="num-name" style={inputStyle} />
                <input type="email" placeholder="Email" required value={numForm.email} onChange={e => setNumForm(f => ({ ...f, email: e.target.value }))} data-testid="num-email" style={inputStyle} />
                <input type="tel" placeholder="Telephone (optionnel)" value={numForm.phone} onChange={e => setNumForm(f => ({ ...f, phone: e.target.value }))} data-testid="num-phone" style={inputStyle} />
                <input type="number" placeholder="Nombre de photos estime" value={numForm.photo_count} onChange={e => setNumForm(f => ({ ...f, photo_count: e.target.value }))} data-testid="num-count" style={inputStyle} />
                <textarea placeholder="Decrivez votre projet..." required value={numForm.description} onChange={e => setNumForm(f => ({ ...f, description: e.target.value }))} data-testid="num-description" rows={3} style={{ ...inputStyle, resize: 'vertical' }} />
                <button type="submit" data-testid="num-submit" style={{
                  fontFamily: "'Georgia', serif", fontSize: 14, fontWeight: 600, letterSpacing: 0.5,
                  background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000', border: 'none',
                  padding: '12px 24px', borderRadius: 8, cursor: 'pointer', width: '100%',
                }}>{t('ecl_send_invitation')}</button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default NumerisationModal;
